export function nameCase(name: string) {
  if (!name) {
    return ``;
  }
  return `${name?.[0]?.toUpperCase()}${name?.substring(1)}`;
}

export const ordinalWord = (i: number) =>
  [`first`, `second`, `third`, `fourth`][i] ?? `${i + 1}th`;

export const ordinalNumber = (n) => {
  const j = n % 10;
  const k = n % 100;
  if (j === 1 && k !== 11) {
    return `${n}st`;
  }
  if (j === 2 && k !== 12) {
    return `${n}nd`;
  }
  if (j === 3 && k !== 13) {
    return `${n}rd`;
  }
  return `${n}th`;
};
